import { getInstance } from '../../../scripts/lib/views';

export default class BookingManager {

  constructor ($el) {
    this.$el = $el;

    this.checkedClass = 'dxWeb_edtCheckBoxChecked_SoftOrange';
    this.uncheckedClass = 'dxWeb_edtCheckBoxUnchecked_SoftOrange';

    this.$success = $el.querySelector('#saveSuccess');
    this.$checkbox = $el.querySelector('.dxICheckBox_SoftOrange');

    this.$successOverlay = getInstance(document.querySelector('.booking__overlay--success'));
    this.$cancelOverlay = getInstance(document.querySelector('.booking__overlay--cancelled'));

    this.$cancelCheckbox = $el.querySelector('.dxICheckBox_SoftOrange');
    this.$cancelCheckboxInput = $el.querySelector('[name="TicketModels[0].IsCanceled"]');

    if (this.$cancelCheckbox && this.$cancelCheckboxInput) {
      this.$cancelCheckbox.addEventListener('click', this.onCancelClick.bind(this));
    }

    this.init();
  }

  init () {
    if (this.isSuccessfull()) {
      this.$successOverlay.toggleOverlay();
    }

    if (this.isCancelled()) {
      this.$cancelOverlay.toggleOverlay();
      this.$checkbox.classList.add('booking--cancelled');
    }
  }

  onCancelClick (event) {
    event.preventDefault();
    event.stopPropagation();

    this.$cancelCheckbox.classList.toggle(this.checkedClass);
    this.$cancelCheckbox.classList.toggle(this.uncheckedClass);
    this.$cancelCheckboxInput.checked = !this.$cancelCheckboxInput.checked;
  }

  isSuccessfull () {
    return this.$success !== null;
  }

  isCancelled () {
    const $cancelLabel = this.$checkbox.parentElement.parentElement.querySelector('.dxichTextCellSys label');

    return $cancelLabel !== null && $cancelLabel.innerText === 'Storniert';
  }
}
